import { useLocation } from "react-router-dom";
import { tzLabel } from "./time";

export function useLang() {
  const { pathname } = useLocation();
  return pathname.startsWith("/en") ? "en" : "de";
}

export function useT() {
  const lang = useLang();
  return (de, en) => (lang === "en" ? en : de);
}

export const PATHS = {
  de: { home: "/de/", tips: "/de/tennis-wetttipps/", today: "/de/wetttipps-heute/", record: "/de/bilanz/", news: "/de/news/", vip: "/de/vip/",
    account: "/de/konto", login: "/de/login", register: "/de/register", imprint: "/de/impressum/", privacy: "/de/datenschutz/", terms: "/de/agb/",
    responsible: "/de/verantwortungsvolles-spielen/", sport: "/de/sportwetten-tipps/", tennisSport: "/de/tennis-sportwetten-tipps/", guides: "/de/ratgeber/",
    predictions: "/de/tennis-prognosen/", live: "/de/tennis-live-wetten-tipps/" },
  en: { home: "/en/", tips: "/en/tennis-betting-tips/", today: "/en/tennis-predictions-today/", record: "/en/record/", news: "/en/news/", vip: "/en/vip/",
    account: "/en/account", login: "/en/login", register: "/en/register", imprint: "/en/imprint/", privacy: "/en/privacy/", terms: "/en/terms/",
    responsible: "/en/responsible-gambling/", sport: "/en/sports-betting-tips/", tennisSport: "/en/tennis-tips/", guides: "/en/guides/",
    predictions: "/en/tennis-predictions/", live: "/en/tennis-live-betting-tips/" },
};

export const TOURS = [["atp", "ATP"], ["wta", "WTA"], ["grand-slam", "Grand Slams"], ["challenger", "Challenger"], ["wta125", "WTA 125"], ["itf", "ITF"]];

const CC = "AD AE AF AG AL AM AO AR AT AU AZ BA BB BD BE BF BG BH BI BJ BN BO BR BS BT BW BY BZ CA CD CF CG CH CI CL CM CN CO CR CU CV CY CZ DE DJ DK DM DO DZ EC EE EG ER ES ET FI FJ FM FR GA GB GD GE GH GM GN GQ GR GT GW GY HK HN HR HT HU ID IE IL IN IQ IR IS IT JM JO JP KE KG KH KI KM KN KR KW KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MG MH MK ML MM MN MO MR MT MU MV MW MX MY MZ NA NE NG NI NL NO NP NR NZ OM PA PE PG PH PK PL PT PW PY QA RO RS RU RW SA SB SC SD SE SG SI SK SL SM SN SO SR SS ST SV SY SZ TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VN VU WS YE ZA ZM ZW";
export function countries(lang) {
  const dn = new Intl.DisplayNames([lang], { type: "region" });
  return CC.split(" ").map((c) => [c, dn.of(c)]).sort((a, b) => a[1].localeCompare(b[1]));
}

export const fmtDate = (s, lang) => (s ? new Date(s).toLocaleString(lang === "en" ? "en-GB" : "de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) + (lang === "en" ? ` ${tzLabel(s)}` : " Uhr") : "");
export const fmtDay = (s, lang) => (s ? new Date(s).toLocaleDateString(lang === "en" ? "en-GB" : "de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "short", year: "numeric" }) : "");
